import { SVGPropsIcon } from 'src/types';

export const Coins = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="coins-cash-svgrepo-com 1" clipPath="url(#clip0_14553_51900)">
        <path
          id="Vector"
          d="M23.3213 2.24135C21.0753 1.11846 18.1195 0.5 14.9984 0.5C11.8771 0.5 8.92115 1.11846 6.6752 2.24146C4.12889 3.51471 2.72656 5.31746 2.72656 7.31773V23.6823C2.72656 25.6825 4.12889 27.4854 6.67531 28.7586C8.92133 29.8816 11.8772 30.5 14.9985 30.5C18.1196 30.5 21.0753 29.8815 23.3213 28.7585C25.8678 27.4852 27.2701 25.6825 27.2701 23.6822V7.31768C27.2702 5.3174 25.8678 3.51471 23.3213 2.24135ZM14.9984 3.22742C20.4611 3.22742 24.5427 5.38689 24.5427 7.31773C24.5427 9.24857 20.4611 11.4081 14.9984 11.4081C9.53574 11.4081 5.45398 9.24852 5.45398 7.31773C5.45398 5.38689 9.53568 3.22742 14.9984 3.22742ZM24.5428 23.6822C24.5428 25.613 20.461 27.7726 14.9984 27.7726C9.53568 27.7726 5.45393 25.613 5.45393 23.6822V22.5935C5.82588 22.845 6.23287 23.0826 6.67525 23.3037C8.92127 24.4268 11.8771 25.0452 14.9985 25.0452C18.1196 25.0452 21.0753 24.4268 23.3213 23.3037C23.7638 23.0824 24.1708 22.845 24.5428 22.5935V23.6822ZM24.5429 18.2274H24.5428C24.5428 20.1583 20.4611 22.3178 14.9985 22.3178C9.5358 22.3178 5.45404 20.1582 5.45404 18.2274V17.1388C5.826 17.3902 6.23299 17.6276 6.67537 17.8488C8.92139 18.972 11.8773 19.5904 14.9986 19.5904C18.1197 19.5904 21.0754 18.9719 23.3214 17.8488C23.7639 17.6275 24.1709 17.3901 24.5429 17.1385V18.2274ZM24.5429 12.7725H24.5428C24.5428 14.7034 20.4611 16.863 14.9985 16.863C9.5358 16.863 5.45404 14.7035 5.45404 12.7725V11.6839C5.826 11.9354 6.23299 12.1728 6.67537 12.3939C8.92133 13.517 11.8773 14.1354 14.9986 14.1354C18.1197 14.1354 21.0754 13.517 23.3214 12.3939C23.7639 12.1726 24.1709 11.9352 24.5429 11.6837V12.7725Z"
          fill="#FEC703"
        />
      </g>
      <defs>
        <clipPath id="clip0_14553_51900">
          <rect width="30" height="30" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
